  <div class="custom-input-container date-with-icon">
  <label>
    {{ label }}
    <span *ngIf="IsRequired" class="required-asterisk">*</span>
  </label>
  <input
    #d="ngbDatepicker"
    type="text"
    ngbDatepicker
    [formControl]="innerControl"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    (change)="onDateChange($event)"
    (blur)="onBlur()"
    [ngClass]="{ 'error-field': validate() }"
    (dateSelect)="onDateSelect($event)"
    (keyup)="emitOnKeyDown($event)"
     (input)="emitOnKeyDown($event)"
     maxlength=10
  />

  <i class="far fa-calendar-alt calendar-icon" (click)="d.toggle()"></i>

  <div *ngIf="isInvalid || IsFillDtExdedThanOrderDt" class="error_msg_required">
    {{ IsFillDtExdedThanOrderDt ? 'Fill Date Cannot be less than Order Date.' : label + ' is required' }}
  </div>
</div>

